import { makeObservable, observable, action } from "mobx";

import { LabelValue } from "../../models/Dashboard/Analytics";
import { NPSAnalyticsAPIFilters } from "../../models/Dashboard/NPSDashboard/NPSAnalyticsFilters";
import NPSAnalyticsDashboardAPI from "../../api/dashboards/NPSAnalyticsDashboardAPI";

export class NPSAnalyticsDashboardStore {
  analyticsAPI: NPSAnalyticsDashboardAPI;
  basic_tats: LabelValue[];
  nps_tats: LabelValue[];

  constructor() {
    this.analyticsAPI = new NPSAnalyticsDashboardAPI();
    this.basic_tats = [];
    this.nps_tats = [];

    makeObservable(this, {
      basic_tats: observable,
      nps_tats: observable,
      getArchivedProjectsAnalyticsTats: action,
      getNPSAnalyticsTats: action,
    });
  }

  getArchivedProjectsAnalyticsTats = async (
    filters: NPSAnalyticsAPIFilters
  ) => {
    try {
      const data = (await this.analyticsAPI.getTatsData(
        "tats",
        filters
      )) as LabelValue[];
      this.basic_tats = data;
    } catch (error) {
      console.error("Error fetching Data", error);
    }
  };

  getNPSAnalyticsTats = async (filters: NPSAnalyticsAPIFilters) => {
    try {
      const data = (await this.analyticsAPI.getTatsData(
        "nps-form-details/tats",
        filters
      )) as LabelValue[];
      this.nps_tats = data;
    } catch (error) {
      console.error("Error fetching Data", error);
    }
  };
}
